import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import apiMiddleware from "./middleware/api";
import reducers from "./reducers";

export function makeStore() {
    return configureStore({
        reducer: reducers,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: false,
                immutableCheck: {
                    ignoredPaths: ["trainingPlan"],
                },
            }).concat(apiMiddleware),
    });
}

const store = makeStore();

export type AppState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, AppState, unknown, Action<string>>;

export default store;
